import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import GlobalStyle from '../styles/global';
import { Home } from './components/Home';
import { Consulting } from './components/Consulting';
import { Training } from './components/Training';
import { AiServices } from './components/AiServices';
import { LocalizedRoute } from './i18n/components/LocalizedRoute';
import { AI_SERVICES_PATH, CONSULTING_PATH, TRAINING_PATH } from './constants/routes';
import { USE_CASE_PATHS } from './config/useCasesConfig';

export const App: React.FC = () => (
  <>
    <GlobalStyle />
    <BrowserRouter>
      <Routes>
        <Route
          path="/:lang"
          element={
            <LocalizedRoute>
              <Home />
            </LocalizedRoute>
          }
        />
        <Route
          path="/"
          element={
            <LocalizedRoute>
              <Home />
            </LocalizedRoute>
          }
        />
        {Object.values(USE_CASE_PATHS).flatMap((path) =>
          [`/:lang${path}`, path].map((route) => (
            <Route
              key={route}
              path={route}
              element={
                <LocalizedRoute>
                  <Home />
                </LocalizedRoute>
              }
            />
          )),
        )}
        <Route
          path={`/:lang${CONSULTING_PATH}`}
          element={
            <LocalizedRoute>
              <Consulting />
            </LocalizedRoute>
          }
        />
        <Route
          path={CONSULTING_PATH}
          element={
            <LocalizedRoute>
              <Consulting />
            </LocalizedRoute>
          }
        />
        <Route
          path={`/:lang${TRAINING_PATH}`}
          element={
            <LocalizedRoute>
              <Training />
            </LocalizedRoute>
          }
        />
        <Route
          path={TRAINING_PATH}
          element={
            <LocalizedRoute>
              <Training />
            </LocalizedRoute>
          }
        />
        <Route
          path={`/:lang${AI_SERVICES_PATH}`}
          element={
            <LocalizedRoute>
              <AiServices />
            </LocalizedRoute>
          }
        />
        <Route
          path={AI_SERVICES_PATH}
          element={
            <LocalizedRoute>
              <AiServices />
            </LocalizedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  </>
);
